import { Meteor } from 'meteor/meteor'

const askPreauthCB = async () => {
  const preauth = await Meteor.promise('createPreauth', {
    mobile: false,
    webApp: true,
    routeReturn: window.location.pathname,
  })

  if (!preauth) throw new Error('Unknow Error')
  if (preauth.status === 'failed') throw new Error(preauth.message)

  return preauth.clientSecret
}

export default askPreauthCB
